import React from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import {ErrorBoundary} from 'react-error-boundary';

import {PrivateTemplate} from 'presentation/templates';
import {ErrorFallback} from 'presentation/components';
import {MyHospitalizationFlowEnum, SignInEnum} from 'presentation/constants';
import {getAccessToken} from 'infra/http/utils';

export const PrivateRoutes = () => {
	const accessToken = getAccessToken();
	const {pathname} = useLocation();

	if (!accessToken) {
		if (pathname === MyHospitalizationFlowEnum.GENERAL_ORIENTATIONS) {
			return (
				<Navigate
					to={SignInEnum.SIGN_IN}
					state={{
						goToSignInState: true,
						pathFrom: MyHospitalizationFlowEnum.GENERAL_ORIENTATIONS,
					}}
					replace
				/>
			);
		}
		return <Navigate to={SignInEnum.SIGN_IN} state={{goToSignInState: true}} replace />;
	}

	return (
		<ErrorBoundary
			FallbackComponent={({resetErrorBoundary}) => (
				<ErrorFallback resetErrorBoundary={resetErrorBoundary} />
			)}
			onReset={() => window.location.reload()}>
			<PrivateTemplate />
		</ErrorBoundary>
	);
};
